import Contact from '@Components/Contact';
import { usePickupDropoffAccess } from '@Hook/usePickupDropoffAccess';
import { useAiValidation } from '../../../hooks/useAiValidation';
import {
  FormHelperText,
  Grid,
  InputLabel,
  SelectChangeEvent,
  TextField,
  Typography,
  useMediaQuery,
  useTheme,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Chip,
  CircularProgress,
  Box,
  Button,
  alpha,
} from '@mui/material';
import { ValidationResult } from 'joi';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Divider from '../../../components/Divider';
import SBDropdown from '../../../components/Dropdown';
import { DropdownOptionType } from '../../../components/Dropdown/Type';
import GoogleMaps from '../../../components/Location';
import SbTextField from '../../../components/Textfield';
import CreateShipmentContext from '../../../context/CreateShipment';
import { getFormattedLocation } from '../../../services/formateLocation';
import { AppDispatch, RootStateType } from '../../../store';
import { addAddress } from '../../../store/reducers/SavedAddress';
import { AddressType } from '../../../store/reducers/SavedAddress/Type';
import {
  createShipmentContextType,
  userDetailsErrorType,
  userDetailsProps,
  userDetailsType,
} from '../../../types/shipment';
import Actions from '../Actions';
import SavedAddresses from '../SavedAddresses';
import ShipmentPickupType from '../ShipmentPickupType';
import {
  USER_TYPE,
  defaultErrorState,
  defaultUserState,
  defaultShipperState,
  defaultConsignee,
  defaultPackageState,
  defaultShipmentTypeState,
  defaultBoxesState,
  defaultBoxState,
  defaultProductState,
  defaultPickupState,
} from '../constants';
import { ShipmentUserSchema } from './Schema';
// import { resetFormData } from '@Reducers/GetRates';
import SbButton from '../../../components/Button';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import { isExcelFile } from './utils/fileType';
import { convertExcelToCsv } from './services/excelParser';
import {
  uploadExcelData,
  getUploadUrl,
  uploadToS3,
  getUploadUrls,
  PresignedUrlsResponse,
} from './services/uploadService';

import {
  extractDocument,
  extractTextDetails,
  startBatchExtraction,
  getBatchExtractionStatus,
} from './services/extractionService';
import ImportAiModal from './ImportAiModal';
import { useNavigate } from 'react-router-dom';
import EditBulkShipmentModal from './EditBulkShipmentModal';
import { BulkShipmentType, BoxType } from '../../../types/shipment';
import EditIcon from '@mui/icons-material/Edit';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ErrorIcon from '@mui/icons-material/Error';
import WarningIcon from '@mui/icons-material/Warning';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import dayjs from 'dayjs';
import { productDescriptionSchema } from '../ShipmentDetails/ProductDescription/schema';
import PickupDrop from '../../../components/Shipment/PickupDrop';
import ShippingOptionSelect from '@Components/ShippingOptionSelect/ShippingOptionSelect';
import { getRates } from '@Reducers/RateSummary';
import { getServiceList } from '@Reducers/CarrierAndService';
import { placeBulkShipment } from '../../../store/reducers/Shipment/actions';
import { getShipmentPayload } from '../../../services/getShipmentPayload';
import { getWarehouseListForShipment } from '@Reducers/Warehouse';
import { transformShipments } from '../../../utils/transformShipments';
import { fetchWarehouseBulkRates } from '@Reducers/WarehouseBooking/warehouseBookingSlice';
import { SuccessErrorModalOpen, SuccessErrorModalReset } from '@Reducers/SuccessErrorModal';
import { WarehouseBookingSection } from '@Components/WarehouseBooking/WarehouseBookingApp';
import useAccountLookup from '@Hook/useAccountLookup';
import { setSelectedUser, setReduxState } from '@Reducers/AccountLookup';
import { RateObj } from '@Reducers/RateSummary/Type';
import { Warehouse as WarehouseIcon, LocalShipping as ShippingIcon } from '@mui/icons-material';
import { PickupDataType, PickupType, GetShipmentPayloadType } from '../../../types/shipment';
import Loader from '../../../components/Loader';

function UserDetails(props: userDetailsProps): JSX.Element {
  const dispatch = useDispatch<AppDispatch>();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const organizationData = useSelector((state: RootStateType) => state.orgSetup.organizationPublicData);
  const { name = '' } = organizationData || {};

  const countryHashById = useSelector((state: RootStateType) => state.global.countriesNameObj);
  const { countryList, currencyList } = useSelector((state: RootStateType) => state?.global);
  const { savedAddressById, shipperAddresses, consigneeAddresses } = useSelector(
    (state: RootStateType) => state?.savedAddress,
  );
  const { shipmentSetting } = useSelector((state: RootStateType) => state?.orgSetup);
  const organizationCountry = useSelector((state: RootStateType) => state.orgSetup.organizationData);
  const pincodeServiceabilityForShipment = useSelector(
    (state: RootStateType) => state?.pincode.pincodeServiceabilityForShipment,
  );
  const { pickupTimeSlots } = shipmentSetting || {};

  const {
    activeStep,
    setActiveStep,
    shipper,
    setShipper,
    consignee,
    setConsignee,
    pickupType,
    setPackageData,
    setShipmentType,
    setBoxes,
    setSelectedBox,
    setSelectedProduct,
    userId,
  } = React.useContext(CreateShipmentContext) as createShipmentContextType;
  const { detailsFor, onBatchModeChange } = props;
  const [initials, setInitials] = useState<userDetailsType>({ ...defaultUserState });
  const [errors, setErrors] = useState<userDetailsErrorType>({ ...defaultErrorState });
  const [reinitialize, setReinitialize] = useState<boolean>(true);
  const [saveAs, setSaveAs] = useState<string>('');
  const [selectedAddress, setSelectedAddress] = useState<AddressType>();
  const fileInputRef = React.useRef<HTMLInputElement>(null);
  const [isImporting, setIsImporting] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [extractionError, setExtractionError] = useState<string | null>(null);
  const navigate = useNavigate();
  const [isBatchMode, setIsBatchMode] = useState<boolean>(false);

  /** Wrapper that updates local state AND notifies the parent (for Stepper hiding) */
  const handleSetBatchMode = (value: boolean) => {
    setIsBatchMode(value);
    onBatchModeChange?.(value);
  };

  const [batchStep, setBatchStep] = useState<number>(0);
  const [batchPickupType, setBatchPickupType] = useState<PickupDataType>({
    ...defaultPickupState,
    date: dayjs(),
    type: name === 'Cargo Solutions Network' ? 'dropOff' : 'pickUp',
  });
  const [carrierPreference, setCarrierPreference] = useState<string>('');
  const [rateAssignService, setRateAssignService] = useState<RateObj[]>([]);
  const [carrierPreferenceList, setCarrierPreferenceList] = useState<any[]>([]);
  const [selectedCarrier, setSelectedCarrier] = useState<string | null>(null);
  const [selectedSystem, setSelectedSystem] = useState<string | null>(null);
  const [warehouseFetched, setWarehouseFetched] = useState(false);

  const { serviceDropdownList } = useSelector((state: RootStateType) => state.carrierAndService);
  const countryHashByIdRates = useSelector((state: RootStateType) => state.global.countriesObj);
  const { warehouseListForShipmentOptionsHashById } = useSelector((state: RootStateType) => state.Warehouse);
  const { warehouseListForShipent } = useSelector((state: RootStateType) => state.Warehouse);
  const { profile } = useSelector((state: RootStateType) => state.loginUser);
  const { selectedUser } = useAccountLookup('CreateShipment');

  const [batchCounts, setBatchCounts] = useState<{
    pending: number;
    completed: number;
    failed: number;
    needs_review: number;
  }>({ pending: 0, completed: 0, failed: 0, needs_review: 0 });
  const [bulkShipments, setBulkShipments] = useState<any[]>([]);
  const [editingShipmentIndex, setEditingShipmentIndex] = useState<number | null>(null);

  const activePollingRef = React.useRef<{ cancelled: boolean } | null>(null);

  useEffect(() => {
    return () => {
      if (activePollingRef.current) {
        activePollingRef.current.cancelled = true;
      }
    };
  }, []);

  const validateAddressJoi = (addr: any) => {
    const cleanAddr = {
      ...addr,
      phoneNumber: addr.phoneNumber ? Number(addr.phoneNumber) : undefined,
      telephoneCode: addr.telephoneCode ? Number(addr.telephoneCode) : undefined,
    };
    const { error } = ShipmentUserSchema.validate(cleanAddr, { abortEarly: false });
    if (!error) return [];
    return error.details.map((d: any) => d.path[0] as string);
  };

  const validateProductJoi = (prod: any) => {
    const cleanProd = {
      ...prod,
      quantity: prod.quantity ? Number(prod.quantity) : undefined,
      unitValue: prod.unitValue ? Number(prod.unitValue) : undefined,
    };
    const { error } = productDescriptionSchema.validate(cleanProd, { abortEarly: false });
    if (!error) return [];
    return error.details.map((d: any) => d.path[0] as string);
  };

  const validateShipmentFields = (shipment: any) => {
    const shipperErrors = validateAddressJoi(shipment.shipper);
    const consigneeErrors = validateAddressJoi(shipment.consignee);

    const p = shipment.package || {};
    const packageErrors: string[] = [];
    if (!p.unitOfMeasurement?.trim()) packageErrors.push('unitOfMeasurement');
    if (!p.currency?.trim()) packageErrors.push('currency');
    if (!p.shipmentMode?.trim()) packageErrors.push('shipmentMode');

    const isExport = shipment.shipper?.country?.toLowerCase() !== shipment.consignee?.country?.toLowerCase();
    if (isExport) {
      const dutyType = p.dutyCharge ? (typeof p.dutyCharge === 'string' ? p.dutyCharge : p.dutyCharge.type || '') : '';
      if (!dutyType?.trim()) {
        packageErrors.push('dutyCharge');
      }
    }

    const boxErrors: { [boxId: string]: string[] } = {};
    const productErrors: { [boxId: string]: { [prodId: string]: string[] } } = {};

    const boxesArray = p.box || [];
    boxesArray.forEach((box: any) => {
      const boxId = box.id || '0';
      const missing: string[] = [];
      const lengthNum = parseFloat(box.length);
      const widthNum = parseFloat(box.width);
      const heightNum = parseFloat(box.height);
      const weightNum = parseFloat(box.weight);

      if (isNaN(lengthNum) || lengthNum <= 0) missing.push('length');
      if (isNaN(widthNum) || widthNum <= 0) missing.push('width');
      if (isNaN(heightNum) || heightNum <= 0) missing.push('height');
      if (isNaN(weightNum) || weightNum <= 0) missing.push('weight');

      if (missing.length > 0) {
        boxErrors[boxId] = missing;
      }

      const productsArray = box.products || [];
      productsArray.forEach((prod: any, prodIdx: number) => {
        const prodId = prod.id || prodIdx.toString();
        const prodMissing = validateProductJoi(prod);
        if (isExport && !prod.HSNCode?.trim()) {
          prodMissing.push('HSNCode');
        }
        if (prodMissing.length > 0) {
          if (!productErrors[boxId]) productErrors[boxId] = {};
          productErrors[boxId][prodId] = prodMissing;
        }
      });
    });

    const isValid =
      shipperErrors.length === 0 &&
      consigneeErrors.length === 0 &&
      packageErrors.length === 0 &&
      Object.keys(boxErrors).length === 0 &&
      Object.keys(productErrors).length === 0;

    return {
      shipperErrors,
      consigneeErrors,
      packageErrors,
      boxErrors,
      productErrors,
      isValid,
    };
  };

  const getPendingFields = (shipment: any): string[] => {
    const valResult = validateShipmentFields(shipment);
    const pending: string[] = [];

    // 1. Shipper fields
    if (valResult.shipperErrors.includes('name')) pending.push('Shipper Name');
    if (valResult.shipperErrors.includes('line1')) pending.push('Shipper Address');
    if (valResult.shipperErrors.includes('city')) pending.push('Shipper City');
    if (valResult.shipperErrors.includes('country')) pending.push('Shipper Country');
    if (valResult.shipperErrors.includes('pincode')) pending.push('Shipper Pincode');
    if (valResult.shipperErrors.includes('phoneNumber')) pending.push('Shipper Phone Number');
    if (valResult.shipperErrors.includes('telephoneCode')) pending.push('Shipper Telephone Code');
    if (valResult.shipperErrors.includes('altContactNo')) pending.push('Shipper Alternate Mobile No.');
    if (valResult.shipperErrors.includes('altContactTelephoneCode')) pending.push('Shipper Alternate Country Code');

    // 2. Consignee fields
    if (valResult.consigneeErrors.includes('name')) pending.push('Consignee Name');
    if (valResult.consigneeErrors.includes('line1')) pending.push('Consignee Address');
    if (valResult.consigneeErrors.includes('city')) pending.push('Consignee City');
    if (valResult.consigneeErrors.includes('country')) pending.push('Consignee Country');
    if (valResult.consigneeErrors.includes('pincode')) pending.push('Consignee Pincode');
    if (valResult.consigneeErrors.includes('phoneNumber')) pending.push('Consignee Phone Number');
    if (valResult.consigneeErrors.includes('telephoneCode')) pending.push('Consignee Telephone Code');
    if (valResult.consigneeErrors.includes('altContactNo')) pending.push('Consignee Alternate Mobile No.');
    if (valResult.consigneeErrors.includes('altContactTelephoneCode')) pending.push('Consignee Alternate Country Code');

    // 3. Package fields
    if (valResult.packageErrors.includes('unitOfMeasurement')) pending.push('Unit of Measurement');
    if (valResult.packageErrors.includes('currency')) pending.push('Currency');
    if (valResult.packageErrors.includes('shipmentMode')) pending.push('Shipment Mode');
    if (valResult.packageErrors.includes('dutyCharge')) pending.push('Duty Charges');

    // 4. Box & Product fields
    const p = shipment.package || {};
    const boxesArray = p.box || [];

    if (boxesArray.length === 0) {
      pending.push('Boxes (At least 1 box is required)');
    } else {
      boxesArray.forEach((box: any, boxIdx: number) => {
        const boxId = box.id || '0';
        const boxErrs = valResult.boxErrors[boxId] || [];
        if (boxErrs.includes('length')) pending.push(`Box ${boxIdx + 1}: Length`);
        if (boxErrs.includes('width')) pending.push(`Box ${boxIdx + 1}: Width`);
        if (boxErrs.includes('height')) pending.push(`Box ${boxIdx + 1}: Height`);
        if (boxErrs.includes('weight')) pending.push(`Box ${boxIdx + 1}: Weight`);

        const prodErrsMap = valResult.productErrors[boxId] || {};
        const productsArray = box.products || [];

        if (productsArray.length === 0) {
          pending.push(`Box ${boxIdx + 1}: Products (At least 1 product is required)`);
        } else {
          productsArray.forEach((prod: any, prodIdx: number) => {
            const prodId = prod.id || prodIdx.toString();
            const prodErrs = prodErrsMap[prodId] || [];
            if (prodErrs.includes('description'))
              pending.push(`Box ${boxIdx + 1}, Product ${prodIdx + 1}: Description`);
            if (prodErrs.includes('quantity')) pending.push(`Box ${boxIdx + 1}, Product ${prodIdx + 1}: Quantity`);
            if (prodErrs.includes('unitValue')) pending.push(`Box ${boxIdx + 1}, Product ${prodIdx + 1}: Unit Value`);
            if (prodErrs.includes('HSNCode')) pending.push(`Box ${boxIdx + 1}, Product ${prodIdx + 1}: HSN Code`);
          });
        }
      });
    }

    return pending;
  };

  const convertJobToBulkShipment = (job: any): BulkShipmentType => {
    const fields = job.fields || {};

    const getCountryName = (cName?: string) => {
      if (!cName) return '';
      const match = (countryList || []).find(
        c => c.value.toLowerCase() === cName.toLowerCase() || c.display.toLowerCase() === cName.toLowerCase(),
      );
      return match ? match.value : cName;
    };

    const cleanPhoneCode = (code?: string) => {
      if (!code) return '';
      const clean = code.trim();
      return clean.startsWith('+') ? clean : `+${clean}`;
    };

    const sanitizePhone = (num?: string): string => (num ? String(num).replace(/[^\d]/g, '') : '');

    const shipper = {
      name: fields.shipper?.name || fields.shipper?.companyName || '',
      companyName: fields.shipper?.companyName || '',
      line1: fields.shipper?.line1 || '',
      line2: fields.shipper?.line2 || '',
      city: fields.shipper?.city || '',
      state: fields.shipper?.state || '',
      country: getCountryName(fields.shipper?.country ? String(fields.shipper.country) : undefined),
      pincode: fields.shipper?.pincode || '',
      phoneNumber: sanitizePhone(fields.shipper?.phone?.number),
      telephoneCode: cleanPhoneCode(fields.shipper?.phone?.telephoneCode),
      email: fields.shipper?.email || '',
      altContactTelephoneCode: '',
      altContactNo: '',
      altContactName: '',
    };

    const consignee = {
      name: fields.consignee?.name || fields.consignee?.companyName || '',
      companyName: fields.consignee?.companyName || '',
      line1: fields.consignee?.line1 || '',
      line2: fields.consignee?.line2 || '',
      city: fields.consignee?.city || '',
      state: fields.consignee?.state || '',
      country: getCountryName(fields.consignee?.country ? String(fields.consignee.country) : undefined),
      pincode: fields.consignee?.pincode || '',
      phoneNumber: sanitizePhone(fields.consignee?.phone?.number),
      telephoneCode: cleanPhoneCode(fields.consignee?.phone?.telephoneCode),
      email: fields.consignee?.email || '',
      altContactTelephoneCode: '',
      altContactNo: '',
      altContactName: '',
    };

    const p = fields.package || {};

    // Parse boxes
    const parsedBoxes: BoxType[] = [];
    if (p.box && Array.isArray(p.box)) {
      p.box.forEach((b: any, index: number) => {
        const boxProducts = (b.products || []).map((prod: any, prodIndex: number) => {
          const quantity = prod.quantity !== undefined && prod.quantity !== null ? Number(prod.quantity) : null;
          const unitValue = prod.unitValue !== undefined && prod.unitValue !== null ? Number(prod.unitValue) : null;
          return {
            id: prodIndex.toString(),
            description: prod.description || '',
            quantity,
            unitValue,
            HSNName: prod.HSNName || '',
            HSNCode: prod.HSNCode ? String(prod.HSNCode) : '',
            totalValue: quantity && unitValue ? quantity * unitValue : 0,
          };
        });

        parsedBoxes.push({
          id: index.toString(),
          length: b.length ? String(b.length) : '',
          width: b.width ? String(b.width) : '',
          height: b.height ? String(b.height) : '',
          weight: b.weight ? String(b.weight) : '',
          boxCopyCount: b.boxCopyCount !== undefined ? Number(b.boxCopyCount) : 0,
          products: boxProducts,
        });
      });
    }

    // If no boxes are parsed, add a default empty box to allow editing
    if (parsedBoxes.length === 0) {
      parsedBoxes.push({
        id: '0',
        length: '',
        width: '',
        height: '',
        weight: '',
        boxCopyCount: 0,
        products: [],
      });
    }

    const totalBoxWeight = parsedBoxes.reduce(
      (prevW, currW) => prevW + (parseFloat(String(currW.weight || 0)) || 0),
      0,
    );

    return {
      isSelected: true,
      carrierPreference: 'cheapest',
      shipper,
      consignee,
      package: {
        unitOfMeasurement: p.unitOfMeasurement || '',
        packaging: typeof p.packaging === 'boolean' ? p.packaging : false,
        insurance: typeof p.insurance === 'boolean' ? p.insurance : false,
        isDocument: typeof p.isDocument === 'boolean' ? p.isDocument : false,
        currency: p.currency || '',
        shipmentMode: fields.shipmentMode || p.shipmentMode || '',
        isCod: typeof p.isCod === 'boolean' ? p.isCod : false,
        isDropOff: typeof p.isDropOff === 'boolean' ? p.isDropOff : false,
        pickupDate: dayjs(),
        timeSlot: '',
        codAmount: p.codAmount ? Number(p.codAmount) : 0,
        box: parsedBoxes,
        totalBoxWeight,
        invoiceNumber: fields.invoiceNumber || '',
        userReferenceNumber: fields.userReferenceNumber || '',
      },
    };
  };

  const updateShipmentsFromJobs = (jobs: any[]) => {
    setBulkShipments(prev => {
      const prevMap = new Map(prev.map(s => [s.jobId, s]));

      return jobs.map((job: any) => {
        if (prevMap.has(job.jobId)) {
          const existing = prevMap.get(job.jobId)!;

          // If the job was pending/processing but is now completed/needs_review,
          // map the new fields from the API response
          const isNewlyCompleted =
            (existing.status === 'pending' || existing.status === 'processing') &&
            (job.status === 'completed' || job.status === 'needs_review');

          if (isNewlyCompleted) {
            const mapped = convertJobToBulkShipment(job);
            return {
              ...mapped,
              jobId: job.jobId,
              status: job.status,
              error: job.error,
              confidence: job.confidence,
              invalidFields: job.invalidFields,
            };
          }

          return {
            ...existing,
            status: job.status,
            error: job.error,
            confidence: job.confidence,
            invalidFields: job.invalidFields,
          };
        }

        const mapped = convertJobToBulkShipment(job);
        return {
          ...mapped,
          jobId: job.jobId,
          status: job.status,
          error: job.error,
          confidence: job.confidence,
          invalidFields: job.invalidFields,
        };
      });
    });
  };

  const fetchRates = async (systemId?: string[]) => {
    try {
      const systemValue: string[] =
        name === 'Cargo Solutions Network'
          ? systemId
            ? systemId
            : []
          : selectedUser?.systems || profile?._systems || [];

      const importRes = await dispatch(
        getRates({
          navigatedDate: batchPickupType.date?.toISOString() || '',
          accountNumber: selectedUser?.accountNumber || profile?.accountNumber || '',
          pageType: 'contract',
          csp: [],
          rateType: [],
          system: systemValue,
          isImport: false,
        }),
      );

      const exportRes = await dispatch(
        getRates({
          navigatedDate: batchPickupType.date?.toISOString() || '',
          accountNumber: selectedUser?.accountNumber || profile?.accountNumber || '',
          pageType: 'contract',
          csp: [],
          rateType: [],
          system: systemValue,
          isImport: true,
        }),
      );

      let importList: RateObj[] = [];
      let exportList: RateObj[] = [];

      if (importRes.type.endsWith('/fulfilled') && importRes.payload && 'data' in importRes.payload) {
        importList = importRes.payload.data.list;
      }

      if (exportRes.type.endsWith('/fulfilled') && exportRes.payload && 'data' in exportRes.payload) {
        exportList = exportRes.payload.data.list;
      }

      setRateAssignService([...importList, ...exportList]);
    } catch (error) {
      console.error('Error fetching rates:', error);
    }
  };

  const getSystemIdFromWarehouse = (selectedWarehouseId: string[], warehouseList: any[]): string[] | undefined => {
    const matchedWarehouse = warehouseList.find(warehouse => warehouse._id === selectedWarehouseId[0]);
    return matchedWarehouse?._systemId;
  };

  const handleWarehouseChange = (
    _selected: Array<string>,
    _selectedObj: DropdownOptionType[],
    _event: SelectChangeEvent<string>,
  ) => {
    const systemId = getSystemIdFromWarehouse(_selected, warehouseListForShipent?.list || []);
    if (systemId) {
      fetchRates(systemId);
    }
    const [selectedWearhouse] = _selected;
    if (selectedWearhouse) {
      const selectedWarehouse = warehouseListForShipmentOptionsHashById[selectedWearhouse];
      const coAttention = selectedWarehouse.coAttention;
      const [telephoneCode, number] = coAttention.contact;
      const countryId = selectedWarehouse._addressId.country;
      const warehouseAddress = {
        ...selectedWarehouse._addressId,
        country: countryHashByIdRates?.[countryId]?.name || '',
        name: selectedWarehouse.name,
        phone: { telephoneCode, number, name: coAttention.name },
        email: coAttention.email,
      };

      setBatchPickupType({
        ...batchPickupType,
        warehouse: selectedWearhouse,
        selectedWearhouseAddress: warehouseAddress,
      });
    }
  };

  const handlePickupTypeChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;
    setBatchPickupType({ ...defaultPickupState, type: value as PickupType });
  };

  const handleTimeSlotChange = (
    _selected: Array<string>,
    _selectedObj: DropdownOptionType[],
    event: SelectChangeEvent<string>,
  ) => {
    const value = event.target.value;
    setBatchPickupType({ ...batchPickupType, timeSlot: value });
  };

  const handlePickupDateChange = (date: dayjs.Dayjs) => {
    setBatchPickupType({ ...batchPickupType, date: date });
  };

  const handleShippingSelect = (pref: string) => {
    setBulkShipments(prev =>
      prev.map(s => {
        if (s.isSelected) {
          return { ...s, carrierPreference: pref };
        }
        return s;
      }),
    );
    setCarrierPreference(pref);
  };

  const handleBook = async (carrierName: string, systemName: string, warehouseID: string) => {
    setSelectedCarrier(carrierName);
    setSelectedSystem(systemName);

    if (warehouseID) {
      const selectedWarehouse = warehouseListForShipmentOptionsHashById[warehouseID];
      const coAttention = selectedWarehouse.coAttention;
      const [telephoneCode, number] = coAttention.contact;
      const countryId = selectedWarehouse._addressId.country;
      const warehouseAddress = {
        ...selectedWarehouse._addressId,
        country: countryHashByIdRates?.[countryId]?.name || '',
        name: selectedWarehouse.name,
        phone: { telephoneCode, number, name: coAttention.name },
        email: coAttention.email,
      };

      setBatchPickupType(prev => ({
        ...prev,
        warehouse: warehouseID,
        selectedWearhouseAddress: warehouseAddress,
      }));
    }
  };

  const handlePlaceBulkShipment = async () => {
    const orgSlots = pickupTimeSlots?.slots?.length;

    if (batchPickupType.type === 'dropOff' && !batchPickupType.warehouse) {
      dispatch(
        SuccessErrorModalOpen({
          type: 'error',
          title: 'Oops!',
          subTitle:
            name === 'Cargo Solutions Network'
              ? 'Please select an Injection Warehouse.'
              : 'Please choose the drop-off warehouse.',
        }),
      );
      return;
    } else if (
      batchPickupType.type === 'pickUp' &&
      (!batchPickupType.date || (orgSlots && !batchPickupType.timeSlot))
    ) {
      dispatch(
        SuccessErrorModalOpen({
          type: 'error',
          title: 'Oops!',
          subTitle: 'Please choose a pickup date and time slot.',
        }),
      );
      return;
    }

    const isDropOff = batchPickupType.type === 'dropOff';

    let pickupDate: string, timeSlot: string;
    const warehouseId = batchPickupType.warehouse;
    const warehouseAddress = batchPickupType.selectedWearhouseAddress;

    let payload: GetShipmentPayloadType = { shipments: bulkShipments, isDropOff };

    payload.shipments = payload.shipments.map(shipment => {
      shipment.package.pickupDate = batchPickupType.date
        ? dayjs(batchPickupType.date).toISOString()
        : dayjs().toISOString();

      const { carrierPreference: pref, ...rest } = shipment;

      if (pref === 'fastest' || pref === 'cheapest') {
        return shipment;
      }

      return {
        ...rest,
        package: shipment.package,
        selectedCourierId: pref,
      };
    });

    if (!isDropOff) {
      pickupDate = dayjs(batchPickupType?.date).toISOString() || dayjs().toISOString();
      timeSlot = batchPickupType.timeSlot;
      payload = { ...payload, pickupDate, timeSlot };
    }

    try {
      const res = await dispatch(
        placeBulkShipment([getShipmentPayload({ ...payload, warehouseId, warehouseAddress }), userId]),
      );

      if (res.payload && 'msg' in res.payload) {
        dispatch(
          SuccessErrorModalOpen({
            type: 'success',
            subTitle: res.payload.msg || 'Bulk shipment created',
            title: 'Success',
            onConfirm: () => {
              navigate('/shipment/bulk-summary');
              dispatch(SuccessErrorModalReset());
            },
          }),
        );
      }
    } catch (err) {
      dispatch(
        SuccessErrorModalOpen({
          type: 'error',
          subTitle: 'Something went wrong',
          title: 'error',
        }),
      );
    }
  };

  useEffect(() => {
    if (isBatchMode) {
      dispatch(getServiceList({}));
    }
  }, [isBatchMode]);

  useEffect(() => {
    if (isBatchMode && name !== 'Cargo Solutions Network') {
      fetchRates();
    }
  }, [isBatchMode, name, selectedUser, profile, batchPickupType.date]);

  useEffect(() => {
    if (isBatchMode && name === 'Cargo Solutions Network' && !warehouseFetched) {
      dispatch(getWarehouseListForShipment());
      setWarehouseFetched(true);
    }

    if (
      isBatchMode &&
      name === 'Cargo Solutions Network' &&
      bulkShipments.length > 0 &&
      !selectedSystem &&
      !selectedCarrier
    ) {
      const result = transformShipments(bulkShipments as never, selectedUser?._id || profile?._id || '');
      if (result.data.length > 0) {
        dispatch(fetchWarehouseBulkRates(result.data)).then((resultRes: any) => {
          if (resultRes.payload?.aggregatedRates.length === 0 && resultRes.payload?.processedShipments === 0) {
            dispatch(
              SuccessErrorModalOpen({
                type: 'error',
                subTitle: 'No rates found for this query!',
                title: 'Try Again!',
              }),
            );
          }
        });
      }
    }
  }, [isBatchMode, bulkShipments, warehouseFetched, name, selectedUser, profile, selectedSystem, selectedCarrier]);

  useEffect(() => {
    if (!isBatchMode) return;
    const validCSPs = new Set(rateAssignService.map(r => r.csp));
    const filteredServices = serviceDropdownList.filter(service => validCSPs.has(service.value));

    const defaultCarrierPreference = [
      { display: 'Fastest', value: 'fastest' },
      { display: 'Cheapest', value: 'cheapest' },
    ];

    if (name === 'Cargo Solutions Network') {
      setCarrierPreferenceList([...defaultCarrierPreference, ...filteredServices]);
    } else if (filteredServices.length) {
      setCarrierPreferenceList([
        ...defaultCarrierPreference,
        { display: 'Others', value: 'other', disable: true },
        ...filteredServices,
      ]);
    } else {
      setCarrierPreferenceList(defaultCarrierPreference);
    }
  }, [name, serviceDropdownList, batchPickupType, selectedUser, rateAssignService, isBatchMode]);

  useEffect(() => {
    if (isBatchMode && batchPickupType.warehouse && selectedCarrier && selectedSystem) {
      handlePlaceBulkShipment();
    }
  }, [isBatchMode, batchPickupType, selectedCarrier, selectedSystem]);

  useEffect(() => {
    if (isBatchMode && selectedUser) {
      dispatch(setReduxState({ modalId: 'createBulkShipment' }));
      dispatch(setSelectedUser(['createBulkShipment', selectedUser]));
    }
  }, [isBatchMode, selectedUser, dispatch]);

  const { validationStates, validate } = useAiValidation();

  // Trigger validation for email
  useEffect(() => {
    if (initials.email) {
      validate('email', 'email', initials.email);
    }
  }, [initials.email, validate]);

  // Trigger validation for phone (shipper.phoneNumber / consignee.phoneNumber: requires number + country + telephoneCode)
  useEffect(() => {
    const countryDisplay = countryHashById?.[initials.country]?.name || initials.country;
    validate(`${detailsFor}.phoneNumber`, 'phone', {
      country: countryDisplay || undefined,
      telephoneCode: initials.telephoneCode || undefined,
      number: initials.phoneNumber || '',
    });
  }, [initials.phoneNumber, initials.country, initials.telephoneCode, countryHashById, validate, detailsFor]);

  // Trigger validation for shipmentAddress only when ALL 4 required values are available: pincode, city, state, country
  useEffect(() => {
    if (initials.pincode && initials.city && initials.state && initials.country) {
      const countryDisplay = countryHashById?.[initials.country]?.name || initials.country;
      validate(`${detailsFor}.address`, 'shipmentAddress', {
        pincode: initials.pincode,
        city: initials.city,
        state: initials.state,
        country: countryDisplay,
      });
    }
  }, [initials.pincode, initials.city, initials.state, initials.country, countryHashById, validate, detailsFor]);

  const handleAiImportClick = () => {
    setIsModalOpen(true);
  };

  const performTextExtraction = async (text: string) => {
    if (!text.trim()) {
      setExtractionError('Please enter some shipment details.');
      return;
    }
    setIsImporting(true);
    setExtractionError(null);
    try {
      const response = await extractTextDetails(text);
      if (response && response.fields) {
        populateFormFromExtractionFields(response.fields);
        setIsModalOpen(false);
      } else {
        console.error('❌ Unexpected text extraction response:', response);
        setExtractionError('The extraction service did not return any fields.');
      }
    } catch (error: any) {
      console.error('❌ Text Extraction Failed:', error);
      setExtractionError(error.message || 'Failed to extract text details.');
    } finally {
      setIsImporting(false);
    }
  };

  const populateFormFromExtractionFields = (fields: any) => {
    const getCountryName = (cName?: string) => {
      if (!cName) return '';
      const match = (countryList || []).find(
        c => c.value.toLowerCase() === cName.toLowerCase() || c.display.toLowerCase() === cName.toLowerCase(),
      );
      return match ? match.value : cName;
    };

    const cleanPhoneCode = (code?: string) => {
      if (!code) return '';
      const clean = code.trim();
      return clean.startsWith('+') ? clean : `+${clean}`;
    };

    const sanitizePhone = (num?: string): string => (num ? String(num).replace(/[^\d]/g, '') : '');

    // 1. Shipper
    const shipperFields = fields.shipper
      ? {
          name: fields.shipper.name || fields.shipper.companyName || '',
          companyName: fields.shipper.companyName || '',
          line1: fields.shipper.line1 || '',
          line2: fields.shipper.line2 || '',
          city: fields.shipper.city || '',
          state: fields.shipper.state || '',
          country: getCountryName(fields.shipper.country ? String(fields.shipper.country) : undefined),
          pincode: fields.shipper.pincode || '',
          phoneNumber: sanitizePhone(fields.shipper.phone?.number),
          telephoneCode: cleanPhoneCode(fields.shipper.phone?.telephoneCode),
          email: fields.shipper.email || '',
        }
      : {};

    setShipper({
      ...defaultShipperState,
      ...shipperFields,
    });

    // 2. Consignee
    const consigneeFields = fields.consignee
      ? {
          name: fields.consignee.name || fields.consignee.companyName || '',
          companyName: fields.consignee.companyName || '',
          line1: fields.consignee.line1 || '',
          line2: fields.consignee.line2 || '',
          city: fields.consignee.city || '',
          state: fields.consignee.state || '',
          country: getCountryName(fields.consignee.country ? String(fields.consignee.country) : undefined),
          pincode: fields.consignee.pincode || '',
          phoneNumber: sanitizePhone(fields.consignee.phone?.number),
          telephoneCode: cleanPhoneCode(fields.consignee.phone?.telephoneCode),
          email: fields.consignee.email || '',
        }
      : {};

    setConsignee({
      ...defaultConsignee,
      ...consigneeFields,
    });

    // 3. Package Data & 4. Shipment Type
    if (fields.package) {
      const p = fields.package;
      setPackageData({
        ...defaultPackageState,
        currency: p.currency || '',
        isDocument: typeof p.isDocument === 'boolean' ? p.isDocument : false,
        userReferenceNumber: fields.userReferenceNumber || '',
      });

      setShipmentType({
        ...defaultShipmentTypeState,
        currency: p.currency || '',
        type: p.isDocument ? 'document' : 'parcel',
        referenceNumber: fields.userReferenceNumber || '',
      });

      // 5. Boxes & Products
      if (p.box && Array.isArray(p.box)) {
        const parsedBoxes = p.box.map((b: any, index: number) => {
          const boxProducts = (b.products || []).map((prod: any, prodIndex: number) => {
            const quantity = prod.quantity !== undefined && prod.quantity !== null ? Number(prod.quantity) : null;
            const unitValue = prod.unitValue !== undefined && prod.unitValue !== null ? Number(prod.unitValue) : null;
            const totalVal = quantity !== null && unitValue !== null ? quantity * unitValue : 0;
            return {
              id: prodIndex.toString(),
              description: prod.description || '',
              quantity,
              unitValue,
              HSNName: prod.HSNName || '',
              HSNCode: prod.HSNCode ? String(prod.HSNCode) : '',
              totalValue: totalVal,
              actions: null,
            };
          });

          return {
            id: index.toString(),
            length: b.length ? String(b.length) : '',
            width: b.width ? String(b.width) : '',
            height: b.height ? String(b.height) : '',
            weight: b.weight ? String(b.weight) : '',
            boxCopyCount: b.boxCopyCount !== undefined ? Number(b.boxCopyCount) : 0,
            products: boxProducts,
            selected: true,
          };
        });

        if (parsedBoxes.length > 0) {
          setBoxes(parsedBoxes);
          setSelectedBox(parsedBoxes[0]);
          if (parsedBoxes[0].products && parsedBoxes[0].products.length > 0) {
            setSelectedProduct(parsedBoxes[0].products[0]);
          }
        } else {
          setBoxes(structuredClone(defaultBoxesState));
          setSelectedBox({ ...defaultBoxState });
          setSelectedProduct({ ...defaultProductState });
        }
      } else {
        setBoxes(structuredClone(defaultBoxesState));
        setSelectedBox({ ...defaultBoxState });
        setSelectedProduct({ ...defaultProductState });
      }
    } else {
      setPackageData({ ...defaultPackageState });
      setShipmentType({ ...defaultShipmentTypeState });
      setBoxes(structuredClone(defaultBoxesState));
      setSelectedBox({ ...defaultBoxState });
      setSelectedProduct({ ...defaultProductState });
    }
  };

  const handleFileChange = async (event: React.ChangeEvent<HTMLInputElement>) => {
    const fileList = event.target.files;
    if (!fileList || fileList.length === 0) return;

    const selectedFiles = Array.from(fileList);

    event.target.value = '';

    if (selectedFiles.length > 100) {
      setExtractionError('Maximum 100 files can be uploaded at a time.');
      return;
    }

    setIsImporting(true);
    setExtractionError(null);

    try {
      if (selectedFiles.length === 1) {
        // Single file flow (Keep existing behavior)
        const file = selectedFiles[0];
        if (isExcelFile(file)) {
          try {
            const csvContent = await convertExcelToCsv(file);
            if (!csvContent) {
              setExtractionError('The uploaded Excel file does not contain any usable data.');
              setIsImporting(false);
              return;
            }

            const response = await uploadExcelData(csvContent);
            console.info(response);

            if (response && response.fields) {
              populateFormFromExtractionFields(response.fields);
              setIsModalOpen(false);
            } else {
              console.error('❌ Unexpected Excel extraction response:', response);
              setExtractionError('The extraction service did not return any fields.');
            }
          } catch (error: any) {
            console.error('❌ Excel Extraction Failed:', error);
            setExtractionError(error.message || 'Failed to extract Excel document details.');
          }
        } else {
          // Step 1: Request Upload URL
          let uploadUrlResponse;
          try {
            uploadUrlResponse = await getUploadUrl(file);
          } catch (error: any) {
            console.error('❌ Upload URL Request Failed:', error);
            setExtractionError(error.message || 'Failed to request upload URL.');
            setIsImporting(false);
            return;
          }

          // Unexpected Response validation
          if (!uploadUrlResponse || !uploadUrlResponse.url || !uploadUrlResponse.fields || !uploadUrlResponse.key) {
            console.error('❌ Unexpected upload URL response:', uploadUrlResponse);
            setExtractionError('The upload URL response is incomplete or invalid.');
            setIsImporting(false);
            return;
          }

          // Step 2: Upload File to S3
          try {
            await uploadToS3(uploadUrlResponse, file);
          } catch (error: any) {
            console.error('❌ S3 Upload Failed:', error);
            setExtractionError(error.message || 'Failed to upload file to S3.');
            setIsImporting(false);
            return;
          }

          // Step 3: Call Extraction API
          try {
            const response = await extractDocument(uploadUrlResponse.key);
            console.info(response);

            if (response && response.fields) {
              populateFormFromExtractionFields(response.fields);
              setIsModalOpen(false);
            } else {
              console.error('❌ Unexpected extraction response:', response);
              setExtractionError('The extraction service did not return any fields.');
            }
          } catch (error: any) {
            console.error('❌ Extraction Failed:', error);
            setExtractionError(error.message || 'Failed to extract document details.');
          }
        }
      } else {
        // Multiple files flow (2–100 files)
        // 1. Get Upload URLs
        const filesPayload = selectedFiles.map(f => ({
          fileName: f.name,
          mimeType: f.type || 'application/octet-stream',
        }));

        let uploadUrlsResponse: PresignedUrlsResponse;
        try {
          uploadUrlsResponse = await getUploadUrls(filesPayload);
        } catch (error: any) {
          console.error('❌ Multi-upload URL Request Failed:', error);
          setExtractionError(error.message || 'Failed to request upload URLs.');
          setIsImporting(false);
          return;
        }

        if (!uploadUrlsResponse || !uploadUrlsResponse.batchId || !Array.isArray(uploadUrlsResponse.files)) {
          console.error('❌ Unexpected upload-urls response:', uploadUrlsResponse);
          setExtractionError('The upload URLs response is incomplete or invalid.');
          setIsImporting(false);
          return;
        }

        if (uploadUrlsResponse.files.length !== selectedFiles.length) {
          console.error('❌ Selected files vs response length mismatch:', uploadUrlsResponse);
          setExtractionError('A different number of upload URLs than requested was returned.');
          setIsImporting(false);
          return;
        }

        // 2. Upload every file to its returned URL
        try {
          await Promise.all(
            selectedFiles.map((file, index) => {
              const uploadInfo = uploadUrlsResponse.files[index];
              return uploadToS3(uploadInfo, file);
            }),
          );
        } catch (error: any) {
          console.error('❌ S3 Batch Upload Failed:', error);
          setExtractionError(error.message || 'Failed to upload all files to S3.');
          setIsImporting(false);
          return;
        }

        // 3. Start Batch Extraction
        const batchKeys = uploadUrlsResponse.files.map(f => f.key);
        try {
          await startBatchExtraction(uploadUrlsResponse.batchId, batchKeys);
        } catch (error: any) {
          console.error('❌ Batch Extraction Request Failed:', error);
          setExtractionError(error.message || 'Failed to initiate batch extraction.');
          setIsImporting(false);
          return;
        }

        // Close upload modal, activate batch mode, clear importing loader
        setIsModalOpen(false);
        handleSetBatchMode(true);
        setIsImporting(false);

        // 4. Poll Batch Status (inline loop in index.tsx)
        const cancelRef = { cancelled: false };
        activePollingRef.current = cancelRef;

        const pollTick = async () => {
          if (cancelRef.cancelled) return;
          try {
            const statusRes = await getBatchExtractionStatus(uploadUrlsResponse.batchId);
            if (cancelRef.cancelled) return;

            setBatchCounts(statusRes.counts || { pending: 0, completed: 0, failed: 0, needs_review: 0 });
            if (statusRes.jobs) {
              updateShipmentsFromJobs(statusRes.jobs);
            }

            console.info(`Batch extraction progress for ${uploadUrlsResponse.batchId}:`, statusRes);

            if (statusRes.counts && statusRes.counts.pending > 0) {
              setTimeout(pollTick, 20000); // Poll every 20 seconds
            } else {
              console.info('Batch extraction completed:', statusRes);
            }
          } catch (err: any) {
            console.error('❌ Batch Extraction Polling Tick Failed:', err);
            // Retry in 20 seconds
            if (!cancelRef.cancelled) {
              setTimeout(pollTick, 20000);
            }
          }
        };

        // Trigger first poll immediately
        pollTick();
      }
    } catch (error: any) {
      console.error('❌ AI Import error:', error);
      setExtractionError(error.message || 'Failed to import documents.');
    } finally {
      setIsImporting(false);
    }
  };

  function saveSelectedAddress(address: AddressType) {
    const { phone, alternatePhone, name, companyName, line1, line2, city, state, country, pincode, email } = address;
    const tempAddress = {
      ...initials,
      name,
      email: email || '',
      companyName: companyName ? companyName : '',
      line1,
      line2: line2 ? line2 : '',
      city,
      state,
      country,
      pincode,
      phoneNumber: phone.number,
      telephoneCode: phone.telephoneCode,
      altContactTelephoneCode: alternatePhone?.telephoneCode ?? '',
      altContactNo: alternatePhone?.number ?? '',
    };

    setInitials({ ...tempAddress });
    return tempAddress;
  }

  useEffect(() => {
    if (savedAddressById?.name) {
      saveSelectedAddress(savedAddressById);
    }
  }, [savedAddressById]);

  useEffect(() => {
    if (detailsFor === USER_TYPE.SHIPPER) {
      setInitials({ ...shipper });
    } else if (detailsFor === USER_TYPE.CONSIGNEE) {
      setInitials({ ...consignee });
    }
  }, [shipper, consignee]);

  useEffect(() => {
    if (selectedAddress) {
      const data = saveSelectedAddress(selectedAddress);
      if (detailsFor === USER_TYPE.SHIPPER) {
        setShipper({ ...shipper, ...data });
      } else if (detailsFor === USER_TYPE.CONSIGNEE) {
        setConsignee({ ...consignee, ...data });
      }
    }
  }, [selectedAddress]);

  useEffect(() => {
    let data = {};
    if (detailsFor === USER_TYPE.SHIPPER) {
      data = { ...shipper };
    } else if (detailsFor === USER_TYPE.CONSIGNEE) {
      data = { ...consignee };
    }
    setInitials(initials => ({ ...initials, ...data }));
    setErrors({ ...defaultErrorState });
    setReinitialize(true);
    setSaveAs('');
  }, [activeStep]);
  function saveOrUpdateSaveAs(initials: userDetailsType) {
    const {
      telephoneCode,
      phoneNumber,
      altContactTelephoneCode,
      altContactNo,
      name,
      companyName,
      line1,
      line2,
      city,
      state,
      country,
      pincode,
      email,
    } = initials;
    const addressObj: AddressType = {
      ...savedAddressById,
      type: detailsFor?.toLocaleLowerCase(),
      phone: {
        telephoneCode: telephoneCode,
        number: phoneNumber,
      },
      name: name,
      email: email,
      companyName: companyName,
      line1: line1,
      line2: line2,
      city: city,
      state: state,
      country: country,
      _countryId: countryHashById?.[country]?._id,
      pincode: pincode,
      label: saveAs,
    };
    if (altContactNo)
      addressObj.alternatePhone = {
        telephoneCode: altContactTelephoneCode,
        number: altContactNo,
      };
    dispatch(addAddress({ payload: addressObj }));
  }

  const validateForm = (event: React.SyntheticEvent) => {
    event.preventDefault();
    const obj: userDetailsType = { ...initials };

    if (!obj.telephoneCode) obj.telephoneCode = organizationCountry?.contactInfo?.telephoneCode?.toString() || '';
    if (!obj.altContactTelephoneCode)
      obj.altContactTelephoneCode = organizationCountry?.contactInfo?.telephoneCode?.toString() || '';

    setInitials({ ...obj });
    const result: ValidationResult = ShipmentUserSchema.validate(obj, { abortEarly: false });
    const { error } = result;
    const errorData: userDetailsErrorType = { ...defaultErrorState };
    if (error) {
      for (const item of error.details) {
        const name = item.path[0];
        const message = item.message;
        errorData[name as keyof userDetailsErrorType] = message;
      }
      setErrors(errorData);
    }

    if (name !== 'Cargo Solutions Network') {
      if (detailsFor === USER_TYPE.SHIPPER) {
        if (pickupType.type === 'dropOff' && !pickupType.warehouse) {
          errorData['warehouse'] = 'Please choose the drop-off warehouse.';
          setErrors(errorData);
          return errorData;
        } else if (pickupType.type === 'pickUp') {
          if (!pickupType.date) {
            errorData['date'] = 'Please choose a pickup date ';
            setErrors(errorData);
            return errorData;
          }
          if (pickupTimeSlots?.slots?.length && !pickupType.timeSlot) {
            errorData['timeSlot'] = 'Please choose a  time slot.';
            setErrors(errorData);
            return errorData;
          }
        }
      }
    }
    if (error === undefined) {
      if (saveAs) saveOrUpdateSaveAs(obj);
      if (detailsFor === USER_TYPE.SHIPPER) {
        const data = { ...shipper, ...obj };
        setShipper({ ...data });
      } else if (detailsFor === USER_TYPE.CONSIGNEE) {
        const data = { ...consignee, ...obj };
        setConsignee({ ...data });
      } else {
        return;
      }
      setActiveStep(activeStep + 1);
    }
  };

  function handleChange(event: React.ChangeEvent<HTMLInputElement>) {
    validateProperty(event);
    const { name, value } = event.target;
    const data = { ...initials };
    data[name as keyof userDetailsType] =
      name === 'phoneNumber' || name === 'altContactNo' ? value.replace(/[^\d]/g, '') : value;
    setInitials(data);
  }

  function handleCountryCodeChange(name: string, value: string) {
    setInitials(initials => ({ ...initials, [name]: value }));
  }

  function handleDropdownChange(
    _selected: Array<string>,
    _selectedObj: DropdownOptionType[],
    event: SelectChangeEvent<string>,
    _child: React.ReactNode,
  ) {
    validateProperty(event);
    const { name, value } = event.target;
    const data = { ...initials };
    data[name as keyof userDetailsType] = value;
    setInitials(data);
  }

  function validateProperty(event: React.ChangeEvent<HTMLInputElement> | SelectChangeEvent<string>) {
    const { name, value } = event.target;
    const obj = { [name]: value };
    const result = ShipmentUserSchema.validate(obj);
    const { error } = result;
    const errorData = { ...errors };
    const errorMessage = error && error.details[0].context?.key === name ? error.details[0].message : null;
    if (errorMessage && name in defaultErrorState) {
      errorData[name as keyof userDetailsErrorType] = errorMessage;
    } else {
      errorData[name as keyof userDetailsErrorType] = '';
    }
    setErrors(errorData);

    // const { name, value } = event.target;
    // const obj = { [name]: value };
    // const result = ShipmentUserSchema.validate(obj);
    // const { error } = result;
    // return error && error.details[0].context?.key === name ? error.details[0].message : null;
  }

  /* eslint-disable @typescript-eslint/no-explicit-any */
  function handleSelectedAddress(event: any) {
    const address = getFormattedLocation(event.address_components);
    setInitials(state => ({ ...state, ...address }));
    setReinitialize(false);
  }

  // const typeOption = useMemo(() => {
  //   const options =
  //     initials.type || personalShipmentId || exportShipmentId
  //       ? initials.type === 'personalShipments'
  //         ? personalShipmentId
  //         : exportShipmentId
  //       : [];
  //   return options?.map(({ label, value }) => ({ display: label, value }));
  // }, [initials.type, exportShipmentId, personalShipmentId]);

  const { disablePickup } = usePickupDropoffAccess({ shipperCountry: initials.country });

  const placementLoading = useSelector((state: RootStateType) => state.shipment.loading || false);

  const isStep1Disabled = (): boolean => {
    // All shipments must be complete and valid
    if (
      bulkShipments.length === 0 ||
      !bulkShipments.every(s => {
        const val = validateShipmentFields(s);
        return (
          s.status !== 'pending' &&
          s.status !== 'processing' &&
          s.status !== 'failed' &&
          s.status !== 'error' &&
          val.isValid
        );
      })
    )
      return true;
    // Pickup / Drop-off must be selected
    const orgSlots = pickupTimeSlots?.slots?.length;
    if (batchPickupType.type === 'dropOff' && !batchPickupType.warehouse) return true;
    if (batchPickupType.type === 'pickUp' && (!batchPickupType.date || (orgSlots && !batchPickupType.timeSlot)))
      return true;
    // Service must be selected (unless CSN which uses warehouse flow)
    if (name !== 'Cargo Solutions Network' && !carrierPreference) return true;
    return false;
  };

  return (
    <>
      <style>{`
        @keyframes geminiGlow {
          0% { background-position: 0% 50%; }
          50% { background-position: 100% 50%; }
          100% { background-position: 0% 50%; }
        }
      `}</style>
      {isBatchMode ? (
        <Box sx={{ width: '100%', mt: 2 }}>
          {batchStep === 0 &&
            (() => {
              const totalShipments = bulkShipments.length;
              const readyShipments = bulkShipments.filter(s => {
                const val = validateShipmentFields(s);
                return (
                  s.status !== 'pending' &&
                  s.status !== 'processing' &&
                  s.status !== 'failed' &&
                  s.status !== 'error' &&
                  val.isValid
                );
              }).length;
              const needsAttentionShipments = totalShipments - readyShipments;
              const allShipmentsValid = totalShipments > 0 && readyShipments === totalShipments;

              return (
                <>
                  {/* Hero Header & Quick Summary Banner */}
                  <Paper
                    elevation={0}
                    sx={{
                      p: { xs: 2, sm: 3 },
                      mb: 3,
                      borderRadius: '16px',
                      border: '1px solid',
                      borderColor: alpha(theme.palette.primary.main, 0.15),
                      background:
                        theme.palette.mode === 'dark'
                          ? alpha(theme.palette.primary.dark, 0.15)
                          : `linear-gradient(135deg, ${alpha(theme.palette.primary.main, 0.04)} 0%, ${alpha(
                              theme.palette.primary.light || theme.palette.primary.main,
                              0.08,
                            )} 100%)`,
                      boxShadow: '0 4px 20px rgba(0,0,0,0.03)',
                    }}
                  >
                    <Grid container spacing={2} alignItems="center">
                      <Grid item xs={12} md={7}>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 0.75 }}>
                          <Chip
                            icon={
                              <AutoAwesomeIcon
                                sx={{ fontSize: '15px !important', color: `${theme.palette.primary.main} !important` }}
                              />
                            }
                            label="AI Multi-Invoice Extraction"
                            size="small"
                            sx={{
                              fontWeight: 700,
                              fontSize: '0.75rem',
                              letterSpacing: '0.3px',
                              bgcolor: alpha(theme.palette.primary.main, 0.1),
                              color: theme.palette.primary.main,
                              borderRadius: '6px',
                              height: '24px',
                            }}
                          />
                          {batchCounts.pending > 0 && (
                            <Chip
                              label="Extracting..."
                              size="small"
                              color="primary"
                              variant="outlined"
                              sx={{ height: '24px', fontSize: '0.75rem', fontWeight: 600 }}
                            />
                          )}
                        </Box>
                        <Typography variant="h5" sx={{ fontWeight: 700, color: theme.palette.text.primary, mb: 0.5 }}>
                          Review Extracted Shipments
                        </Typography>
                        <Typography variant="body2" sx={{ color: theme.palette.text.secondary }}>
                          Speedbox AI has parsed your uploaded documents. Verify details below and resolve missing
                          fields before selecting logistics and services.
                        </Typography>
                      </Grid>

                      {/* Quick KPI Metric Badges */}
                      <Grid item xs={12} md={5}>
                        <Box
                          sx={{
                            display: 'flex',
                            gap: 1.5,
                            justifyContent: { xs: 'flex-start', md: 'flex-end' },
                            flexWrap: 'wrap',
                          }}
                        >
                          {/* Total Card */}
                          <Box
                            sx={{
                              px: 2,
                              py: 1.2,
                              borderRadius: '12px',
                              bgcolor: alpha(theme.palette.text.primary, 0.04),
                              border: `1px solid ${alpha(theme.palette.divider, 0.6)}`,
                              minWidth: '95px',
                              textAlign: 'center',
                            }}
                          >
                            <Typography
                              variant="caption"
                              sx={{
                                fontWeight: 600,
                                color: theme.palette.text.secondary,
                                textTransform: 'uppercase',
                                letterSpacing: '0.5px',
                                fontSize: '0.6875rem',
                              }}
                            >
                              Total Invoices
                            </Typography>
                            <Typography
                              variant="h6"
                              sx={{ fontWeight: 700, color: theme.palette.text.primary, lineHeight: 1.2 }}
                            >
                              {totalShipments}
                            </Typography>
                          </Box>

                          {/* Ready Card */}
                          <Box
                            sx={{
                              px: 2,
                              py: 1.2,
                              borderRadius: '12px',
                              bgcolor: alpha(theme.palette.success.main, 0.08),
                              border: `1px solid ${alpha(theme.palette.success.main, 0.25)}`,
                              minWidth: '95px',
                              textAlign: 'center',
                            }}
                          >
                            <Typography
                              variant="caption"
                              sx={{
                                fontWeight: 600,
                                color: theme.palette.success.main,
                                textTransform: 'uppercase',
                                letterSpacing: '0.5px',
                                fontSize: '0.6875rem',
                              }}
                            >
                              Ready
                            </Typography>
                            <Typography
                              variant="h6"
                              sx={{ fontWeight: 700, color: theme.palette.success.main, lineHeight: 1.2 }}
                            >
                              {readyShipments}
                            </Typography>
                          </Box>

                          {/* Needs Review Card */}
                          <Box
                            sx={{
                              px: 2,
                              py: 1.2,
                              borderRadius: '12px',
                              bgcolor:
                                needsAttentionShipments > 0
                                  ? alpha(theme.palette.warning.main, 0.08)
                                  : alpha(theme.palette.text.primary, 0.04),
                              border: `1px solid ${
                                needsAttentionShipments > 0
                                  ? alpha(theme.palette.warning.main, 0.3)
                                  : alpha(theme.palette.divider, 0.6)
                              }`,
                              minWidth: '95px',
                              textAlign: 'center',
                            }}
                          >
                            <Typography
                              variant="caption"
                              sx={{
                                fontWeight: 600,
                                color:
                                  needsAttentionShipments > 0
                                    ? theme.palette.warning.main
                                    : theme.palette.text.secondary,
                                textTransform: 'uppercase',
                                letterSpacing: '0.5px',
                                fontSize: '0.6875rem',
                              }}
                            >
                              Needs Action
                            </Typography>
                            <Typography
                              variant="h6"
                              sx={{
                                fontWeight: 700,
                                color:
                                  needsAttentionShipments > 0
                                    ? theme.palette.warning.main
                                    : theme.palette.text.secondary,
                                lineHeight: 1.2,
                              }}
                            >
                              {needsAttentionShipments}
                            </Typography>
                          </Box>
                        </Box>
                      </Grid>
                    </Grid>
                  </Paper>

                  {/* Live Polling Banner */}
                  {batchCounts.pending > 0 && (
                    <Paper
                      elevation={0}
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        p: 2,
                        mb: 3,
                        bgcolor: alpha(theme.palette.primary.main, 0.06),
                        borderRadius: '12px',
                        border: `1px solid ${alpha(theme.palette.primary.main, 0.25)}`,
                      }}
                    >
                      <CircularProgress size={22} sx={{ color: theme.palette.primary.main, mr: 2 }} />
                      <Box>
                        <Typography variant="body2" sx={{ color: theme.palette.primary.main, fontWeight: 600 }}>
                          AI Extraction in Progress... ({batchCounts.completed} completed, {batchCounts.pending}{' '}
                          remaining)
                        </Typography>
                        <Typography variant="caption" sx={{ color: theme.palette.text.secondary }}>
                          Extracted shipments appear in real time. Completed rows are immediately reviewable and
                          editable.
                        </Typography>
                      </Box>
                    </Paper>
                  )}

                  {/* Polished Table Container */}
                  <TableContainer
                    component={Paper}
                    elevation={0}
                    sx={{
                      boxShadow: '0 4px 20px rgba(0,0,0,0.05)',
                      borderRadius: '14px',
                      border: `1px solid ${alpha(theme.palette.divider, 0.8)}`,
                      overflowX: 'auto',
                    }}
                  >
                    <Table sx={{ minWidth: 700 }}>
                      <TableHead sx={{ bgcolor: 'var(--mui-palette-primary-main)' }}>
                        <TableRow>
                          <TableCell
                            sx={{
                              fontWeight: 700,
                              color: 'var(--mui-palette-primary-contrastText)',
                              fontSize: '0.875rem',
                              py: 1.8,
                              letterSpacing: '0.3px',
                            }}
                          >
                            Invoice / Shipment
                          </TableCell>
                          <TableCell
                            sx={{
                              fontWeight: 700,
                              color: 'var(--mui-palette-primary-contrastText)',
                              fontSize: '0.875rem',
                              py: 1.8,
                              letterSpacing: '0.3px',
                            }}
                          >
                            Shipper
                          </TableCell>
                          <TableCell
                            sx={{
                              fontWeight: 700,
                              color: 'var(--mui-palette-primary-contrastText)',
                              fontSize: '0.875rem',
                              py: 1.8,
                              letterSpacing: '0.3px',
                            }}
                          >
                            Consignee
                          </TableCell>
                          <TableCell
                            sx={{
                              fontWeight: 700,
                              color: 'var(--mui-palette-primary-contrastText)',
                              fontSize: '0.875rem',
                              py: 1.8,
                              letterSpacing: '0.3px',
                            }}
                          >
                            Product / Boxes
                          </TableCell>
                          <TableCell
                            align="right"
                            sx={{
                              fontWeight: 700,
                              color: 'var(--mui-palette-primary-contrastText)',
                              fontSize: '0.875rem',
                              py: 1.8,
                              letterSpacing: '0.3px',
                            }}
                          >
                            Qty
                          </TableCell>
                          <TableCell
                            align="right"
                            sx={{
                              fontWeight: 700,
                              color: 'var(--mui-palette-primary-contrastText)',
                              fontSize: '0.875rem',
                              py: 1.8,
                              letterSpacing: '0.3px',
                            }}
                          >
                            Weight
                          </TableCell>
                          <TableCell
                            align="right"
                            sx={{
                              fontWeight: 700,
                              color: 'var(--mui-palette-primary-contrastText)',
                              fontSize: '0.875rem',
                              py: 1.8,
                              letterSpacing: '0.3px',
                            }}
                          >
                            Total Value
                          </TableCell>
                          <TableCell
                            sx={{
                              fontWeight: 700,
                              color: 'var(--mui-palette-primary-contrastText)',
                              fontSize: '0.875rem',
                              py: 1.8,
                              letterSpacing: '0.3px',
                            }}
                          >
                            Status
                          </TableCell>
                          <TableCell
                            align="center"
                            sx={{
                              fontWeight: 700,
                              color: 'var(--mui-palette-primary-contrastText)',
                              fontSize: '0.875rem',
                              py: 1.8,
                              letterSpacing: '0.3px',
                            }}
                          >
                            Action
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {bulkShipments.map((shipment: any, index: number) => {
                          const valErrors = validateShipmentFields(shipment);
                          const invoice = shipment.package?.invoiceNumber || `Shipment ${index + 1}`;
                          const isFailed = shipment.status === 'failed' || shipment.status === 'error';
                          const isPending = shipment.status === 'pending' || shipment.status === 'processing';
                          const isNeedsReview = !valErrors.isValid;

                          const formatDecimal = (val: any) => {
                            if (val === undefined || val === null || val === '') return '—';
                            const num = Number(val);
                            if (isNaN(num)) return String(val);
                            return num.toFixed(2);
                          };

                          // Extract product info
                          const firstBox = shipment.package?.box?.[0];
                          const firstProd = firstBox?.products?.[0];
                          const productDesc = firstProd?.description || '—';
                          const qty =
                            firstProd?.quantity !== undefined && firstProd?.quantity !== null
                              ? formatDecimal(firstProd.quantity)
                              : '—';
                          const rawWeight = firstBox?.weight;
                          const weight =
                            rawWeight !== undefined && rawWeight !== null && rawWeight !== ''
                              ? `${formatDecimal(rawWeight)} ${
                                  shipment.package?.unitOfMeasurement?.split('-')?.[0] || 'kg'
                                }`
                              : '—';
                          const calculatedVal = firstBox?.products?.reduce(
                            (sum: number, p: any) => sum + (Number(p.quantity) || 0) * (Number(p.unitValue) || 0),
                            0,
                          );
                          const totalVal =
                            calculatedVal !== undefined && calculatedVal !== null ? calculatedVal.toFixed(2) : '—';

                          const rowAccentColor = isNeedsReview
                            ? '#f57c00'
                            : isFailed
                            ? '#d32f2f'
                            : isPending
                            ? '#7c4dff'
                            : '#2e7d32';

                          return (
                            <TableRow
                              key={shipment.jobId || index}
                              hover
                              sx={{
                                borderLeft: `4px solid ${rowAccentColor}`,
                                transition: 'all 0.2s ease',
                                '&:hover': {
                                  bgcolor: alpha(theme.palette.primary.main, 0.03),
                                },
                              }}
                            >
                              {/* Invoice / Shipment Cell */}
                              <TableCell component="th" scope="row" sx={{ py: 2 }}>
                                <Typography
                                  sx={{ fontWeight: 600, fontSize: '0.925rem', color: theme.palette.text.primary }}
                                >
                                  {invoice}
                                </Typography>
                                <Box
                                  sx={{ display: 'flex', alignItems: 'center', gap: 0.75, mt: 0.5, flexWrap: 'wrap' }}
                                >
                                  <Chip
                                    label={`#${index + 1}`}
                                    size="small"
                                    sx={{
                                      fontSize: '0.6875rem',
                                      height: '20px',
                                      fontWeight: 700,
                                      bgcolor: alpha(theme.palette.text.primary, 0.06),
                                      color: theme.palette.text.secondary,
                                      borderRadius: '4px',
                                    }}
                                  />
                                  {shipment.package?.userReferenceNumber && (
                                    <Typography
                                      variant="caption"
                                      sx={{ color: theme.palette.text.secondary, fontSize: '0.75rem' }}
                                    >
                                      Ref: {shipment.package.userReferenceNumber}
                                    </Typography>
                                  )}
                                </Box>
                              </TableCell>

                              {/* Shipper Cell */}
                              <TableCell sx={{ py: 2 }}>
                                {shipment.shipper?.name ? (
                                  <Box>
                                    <Typography
                                      sx={{ fontWeight: 600, fontSize: '0.9rem', color: theme.palette.text.primary }}
                                    >
                                      {shipment.shipper.name}
                                    </Typography>
                                    <Typography
                                      sx={{ fontSize: '0.75rem', color: theme.palette.text.secondary, mt: 0.25 }}
                                    >
                                      {[shipment.shipper.city, shipment.shipper.country, shipment.shipper.pincode]
                                        .filter(Boolean)
                                        .join(', ')}
                                    </Typography>
                                  </Box>
                                ) : (
                                  <Box
                                    sx={{
                                      display: 'inline-flex',
                                      alignItems: 'center',
                                      px: 1,
                                      py: 0.5,
                                      borderRadius: '4px',
                                      bgcolor: alpha(theme.palette.warning.main, 0.08),
                                    }}
                                  >
                                    <Typography
                                      sx={{
                                        fontSize: '0.8125rem',
                                        color: theme.palette.warning.dark || '#b78103',
                                        fontWeight: 500,
                                      }}
                                    >
                                      Incomplete Shipper
                                    </Typography>
                                  </Box>
                                )}
                              </TableCell>

                              {/* Consignee Cell */}
                              <TableCell sx={{ py: 2 }}>
                                {shipment.consignee?.name ? (
                                  <Box>
                                    <Typography
                                      sx={{ fontWeight: 600, fontSize: '0.9rem', color: theme.palette.text.primary }}
                                    >
                                      {shipment.consignee.name}
                                    </Typography>
                                    <Typography
                                      sx={{ fontSize: '0.75rem', color: theme.palette.text.secondary, mt: 0.25 }}
                                    >
                                      {[shipment.consignee.city, shipment.consignee.country, shipment.consignee.pincode]
                                        .filter(Boolean)
                                        .join(', ')}
                                    </Typography>
                                  </Box>
                                ) : (
                                  <Box
                                    sx={{
                                      display: 'inline-flex',
                                      alignItems: 'center',
                                      px: 1,
                                      py: 0.5,
                                      borderRadius: '4px',
                                      bgcolor: alpha(theme.palette.warning.main, 0.08),
                                    }}
                                  >
                                    <Typography
                                      sx={{
                                        fontSize: '0.8125rem',
                                        color: theme.palette.warning.dark || '#b78103',
                                        fontWeight: 500,
                                      }}
                                    >
                                      Incomplete Consignee
                                    </Typography>
                                  </Box>
                                )}
                              </TableCell>

                              {/* Product Cell */}
                              <TableCell
                                sx={{
                                  maxWidth: 220,
                                  py: 2,
                                }}
                              >
                                <Typography
                                  sx={{
                                    fontWeight: 500,
                                    fontSize: '0.875rem',
                                    color: theme.palette.text.primary,
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    whiteSpace: 'nowrap',
                                  }}
                                >
                                  {productDesc}
                                </Typography>
                                <Typography
                                  variant="caption"
                                  sx={{
                                    color: theme.palette.text.secondary,
                                    fontSize: '0.75rem',
                                    display: 'block',
                                    mt: 0.25,
                                  }}
                                >
                                  {shipment.package?.box?.length || 1} Box(es) ·{' '}
                                  {shipment.package?.box?.[0]?.products?.length || 1} Item(s)
                                </Typography>
                              </TableCell>

                              {/* Qty Cell */}
                              <TableCell align="right" sx={{ py: 2 }}>
                                <Typography
                                  sx={{ fontWeight: 600, fontSize: '0.9rem', color: theme.palette.text.primary }}
                                >
                                  {qty}
                                </Typography>
                              </TableCell>

                              {/* Weight Cell */}
                              <TableCell align="right" sx={{ py: 2 }}>
                                <Typography
                                  sx={{ fontWeight: 600, fontSize: '0.9rem', color: theme.palette.text.primary }}
                                >
                                  {weight}
                                </Typography>
                              </TableCell>

                              {/* Value Cell */}
                              <TableCell align="right" sx={{ py: 2 }}>
                                <Typography
                                  sx={{
                                    fontWeight: 700,
                                    fontSize: '0.9rem',
                                    color: theme.palette.text.primary,
                                  }}
                                >
                                  {totalVal !== '—' && shipment.package?.currency
                                    ? `${shipment.package.currency} `
                                    : ''}
                                  {totalVal}
                                </Typography>
                              </TableCell>

                              {/* Status Cell */}
                              <TableCell sx={{ verticalAlign: 'middle', py: 2 }}>
                                {isPending ? (
                                  <Chip
                                    label="Processing"
                                    variant="outlined"
                                    color="primary"
                                    size="small"
                                    sx={{ fontWeight: 600 }}
                                  />
                                ) : isFailed ? (
                                  <Chip
                                    icon={<ErrorIcon />}
                                    label="Failed"
                                    color="error"
                                    variant="outlined"
                                    size="small"
                                    sx={{ fontWeight: 600 }}
                                  />
                                ) : isNeedsReview ? (
                                  <Box>
                                    <Chip
                                      icon={<WarningIcon />}
                                      label="Needs Attention"
                                      color="warning"
                                      variant="outlined"
                                      size="small"
                                      sx={{ fontWeight: 700, mb: 0.75 }}
                                    />
                                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
                                      <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                                        {getPendingFields(shipment).map(field => (
                                          <Chip
                                            key={field}
                                            label={field}
                                            size="small"
                                            sx={{
                                              fontSize: '0.6875rem',
                                              height: '20px',
                                              fontWeight: 500,
                                              bgcolor: alpha(theme.palette.error.main, 0.08),
                                              color: theme.palette.error.main,
                                              border: `1px solid ${alpha(theme.palette.error.main, 0.2)}`,
                                              borderRadius: '4px',
                                            }}
                                          />
                                        ))}
                                      </Box>
                                    </Box>
                                  </Box>
                                ) : (
                                  <Box>
                                    <Chip
                                      icon={<CheckCircleIcon />}
                                      label="Ready"
                                      color="success"
                                      variant="outlined"
                                      size="small"
                                      sx={{ fontWeight: 700 }}
                                    />
                                    <Typography
                                      variant="caption"
                                      sx={{
                                        color: theme.palette.text.secondary,
                                        display: 'block',
                                        mt: 0.4,
                                        fontSize: '0.725rem',
                                      }}
                                    >
                                      All details verified
                                    </Typography>
                                  </Box>
                                )}
                              </TableCell>

                              {/* Action Cell */}
                              <TableCell align="center" sx={{ py: 2 }}>
                                <Button
                                  variant="outlined"
                                  size="small"
                                  startIcon={<EditIcon />}
                                  onClick={() => setEditingShipmentIndex(index)}
                                  disabled={isPending}
                                  sx={{
                                    borderRadius: '8px',
                                    textTransform: 'none',
                                    fontWeight: 600,
                                    px: 1.5,
                                    borderColor: alpha(theme.palette.primary.main, 0.4),
                                    color: theme.palette.primary.main,
                                    '&:hover': {
                                      borderColor: theme.palette.primary.main,
                                      bgcolor: alpha(theme.palette.primary.main, 0.06),
                                    },
                                  }}
                                >
                                  Edit
                                </Button>
                              </TableCell>
                            </TableRow>
                          );
                        })}
                      </TableBody>
                    </Table>
                  </TableContainer>

                  {/* Navigation actions */}
                  <Paper
                    elevation={0}
                    sx={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                      mt: 3,
                      mb: 2,
                      p: 2,
                      borderRadius: '14px',
                      border: `1px solid ${alpha(theme.palette.divider, 0.8)}`,
                      bgcolor: theme.palette.background.paper,
                      flexWrap: 'wrap',
                      gap: 2,
                    }}
                  >
                    <SbButton
                      variant="outlined"
                      onClick={() => handleSetBatchMode(false)}
                      startIcon={<ArrowBackIcon />}
                    >
                      Back to Upload
                    </SbButton>

                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                      {!allShipmentsValid && (
                        <Typography
                          variant="caption"
                          sx={{
                            color: theme.palette.warning.dark || '#b78103',
                            fontWeight: 600,
                            fontSize: '0.8125rem',
                            display: { xs: 'none', sm: 'block' },
                          }}
                        >
                          ⚠️ Please resolve required fields in all shipments before continuing
                        </Typography>
                      )}
                      <SbButton
                        variant="contained"
                        onClick={() => setBatchStep(1)}
                        disabled={!allShipmentsValid}
                        endIcon={<ArrowForwardIcon />}
                        sx={{
                          py: 1,
                          px: 3,
                          fontWeight: 700,
                          borderRadius: '8px',
                          boxShadow: allShipmentsValid
                            ? `0 4px 14px ${alpha(theme.palette.primary.main, 0.3)}`
                            : 'none',
                        }}
                      >
                        Continue to Services
                      </SbButton>
                    </Box>
                  </Paper>
                </>
              );
            })()}

          {batchStep === 1 && (
            <Loader loading={placementLoading || false} overly>
              <Box sx={{ width: '100%' }}>
                {/* Step 1 Header Banner */}
                <Paper
                  elevation={0}
                  sx={{
                    p: { xs: 2, sm: 3 },
                    mb: 3,
                    borderRadius: '16px',
                    border: '1px solid',
                    borderColor: alpha(theme.palette.primary.main, 0.15),
                    background:
                      theme.palette.mode === 'dark'
                        ? alpha(theme.palette.primary.dark, 0.15)
                        : `linear-gradient(135deg, ${alpha(theme.palette.primary.main, 0.04)} 0%, ${alpha(
                            theme.palette.primary.light || theme.palette.primary.main,
                            0.08,
                          )} 100%)`,
                    boxShadow: '0 4px 20px rgba(0,0,0,0.03)',
                  }}
                >
                  <Box
                    sx={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                      flexWrap: 'wrap',
                      gap: 2,
                    }}
                  >
                    <Box>
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 0.5 }}>
                        <Chip
                          label="Step 2 of 2"
                          size="small"
                          sx={{
                            fontWeight: 700,
                            fontSize: '0.75rem',
                            bgcolor: alpha(theme.palette.primary.main, 0.1),
                            color: theme.palette.primary.main,
                            borderRadius: '6px',
                            height: '24px',
                          }}
                        />
                        <Chip
                          icon={
                            <CheckCircleIcon
                              sx={{ fontSize: '14px !important', color: `${theme.palette.success.main} !important` }}
                            />
                          }
                          label={`${bulkShipments.length} Shipments Verified`}
                          size="small"
                          color="success"
                          variant="outlined"
                          sx={{ height: '24px', fontSize: '0.75rem', fontWeight: 600 }}
                        />
                      </Box>
                      <Typography variant="h5" sx={{ fontWeight: 700, color: theme.palette.text.primary, mb: 0.5 }}>
                        Logistics & Service Selection
                      </Typography>
                      <Typography variant="body2" sx={{ color: theme.palette.text.secondary }}>
                        Choose your dispatch method and carrier service rate preference applied across all{' '}
                        {bulkShipments.length} verified bulk parcels.
                      </Typography>
                    </Box>
                  </Box>
                </Paper>

                {/* Main Content Cards */}
                {name === 'Cargo Solutions Network' ? (
                  <Paper
                    elevation={0}
                    sx={{
                      p: 3,
                      borderRadius: '16px',
                      border: `1px solid ${alpha(theme.palette.divider, 0.8)}`,
                      boxShadow: '0 4px 20px rgba(0,0,0,0.04)',
                      bgcolor: theme.palette.background.paper,
                    }}
                  >
                    <Typography variant="h6" sx={{ fontWeight: 700, color: theme.palette.text.primary, mb: 2 }}>
                      Warehouse & Service Selection
                    </Typography>
                    {selectedCarrier && selectedSystem && (
                      <Box sx={{ display: 'flex', gap: 1, mb: 2 }}>
                        <Chip icon={<WarehouseIcon />} label={selectedSystem} color="primary" variant="outlined" />
                        <Chip icon={<ShippingIcon />} label={selectedCarrier} color="secondary" variant="outlined" />
                      </Box>
                    )}
                    <WarehouseBookingSection onClose={() => setBatchStep(0)} onBook={handleBook} />
                  </Paper>
                ) : (
                  <Grid container spacing={3}>
                    {/* Card 1: Dispatch Method (Pickup / Drop-off) */}
                    <Grid item xs={12}>
                      <Paper
                        elevation={0}
                        sx={{
                          p: { xs: 2.5, sm: 3.5 },
                          borderRadius: '16px',
                          border: `1px solid ${alpha(theme.palette.divider, 0.8)}`,
                          boxShadow: '0 4px 20px rgba(0,0,0,0.04)',
                          bgcolor: theme.palette.background.paper,
                        }}
                      >
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: 3 }}>
                          <Box
                            sx={{
                              width: 36,
                              height: 36,
                              borderRadius: '10px',
                              bgcolor: alpha(theme.palette.primary.main, 0.1),
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              color: theme.palette.primary.main,
                            }}
                          >
                            <ShippingIcon fontSize="small" />
                          </Box>
                          <Box>
                            <Typography variant="subtitle1" sx={{ fontWeight: 700, color: theme.palette.text.primary }}>
                              1. Dispatch Method (Pickup or Drop-off) *
                            </Typography>
                            <Typography variant="caption" sx={{ color: theme.palette.text.secondary }}>
                              Select how parcels will be handed over to the courier
                            </Typography>
                          </Box>
                        </Box>

                        <Grid container item xs={12} lg={10} xl={8}>
                          <PickupDrop
                            handlePickupTypeChange={handlePickupTypeChange}
                            pickupType={batchPickupType.type}
                            handleTimeSlotChange={handleTimeSlotChange}
                            timeSlot={batchPickupType.timeSlot}
                            handlePickupDateChange={handlePickupDateChange}
                            pickupDate={batchPickupType.date}
                            warehouse={batchPickupType.warehouse}
                            handleWarehouseChange={handleWarehouseChange}
                          />
                        </Grid>
                      </Paper>
                    </Grid>

                    {/* Card 2: Carrier & Service Selection */}
                    <Grid item xs={12}>
                      <Paper
                        elevation={0}
                        sx={{
                          p: { xs: 2.5, sm: 3.5 },
                          borderRadius: '16px',
                          border: `1px solid ${alpha(theme.palette.divider, 0.8)}`,
                          boxShadow: '0 4px 20px rgba(0,0,0,0.04)',
                          bgcolor: theme.palette.background.paper,
                        }}
                      >
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: 3 }}>
                          <Box
                            sx={{
                              width: 36,
                              height: 36,
                              borderRadius: '10px',
                              bgcolor: alpha(theme.palette.primary.main, 0.1),
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              color: theme.palette.primary.main,
                            }}
                          >
                            <WarehouseIcon fontSize="small" />
                          </Box>
                          <Box>
                            <Typography variant="subtitle1" sx={{ fontWeight: 700, color: theme.palette.text.primary }}>
                              2. Carrier & Service Selection *
                            </Typography>
                            <Typography variant="caption" sx={{ color: theme.palette.text.secondary }}>
                              Choose carrier service rate preference applied across all bulk parcels
                            </Typography>
                          </Box>
                        </Box>

                        <Grid container item xs={12} md={6} lg={5}>
                          <ShippingOptionSelect
                            required={name === 'Cargo Solutions Network'}
                            shippingOptions={carrierPreferenceList}
                            onSelect={handleShippingSelect}
                          />
                        </Grid>

                        {carrierPreference !== 'cheapest' && carrierPreference && (
                          <Box
                            sx={{
                              display: 'flex',
                              alignItems: 'center',
                              mt: 3,
                              p: 2,
                              bgcolor: alpha(theme.palette.warning.main, 0.08),
                              border: `1px solid ${alpha(theme.palette.warning.main, 0.25)}`,
                              borderRadius: '10px',
                            }}
                          >
                            <img src="/images/shipment/warning.svg" alt="warning" height={22} width={22} />
                            <Typography
                              variant="body2"
                              sx={{ ml: 1.5, color: theme.palette.warning.dark || '#b78103', fontWeight: 500 }}
                            >
                              Custom carrier preference is selected. Cheapest is usually recommended for bulk
                              dispatches.
                            </Typography>
                          </Box>
                        )}
                      </Paper>
                    </Grid>

                    {/* Placement Footer Card */}
                    <Grid item xs={12}>
                      <Paper
                        elevation={0}
                        sx={{
                          p: 2.5,
                          borderRadius: '16px',
                          border: `1px solid ${alpha(theme.palette.divider, 0.8)}`,
                          bgcolor: theme.palette.background.paper,
                          display: 'flex',
                          justifyContent: 'space-between',
                          alignItems: 'center',
                          flexWrap: 'wrap',
                          gap: 2,
                        }}
                      >
                        <SbButton variant="outlined" onClick={() => setBatchStep(0)} startIcon={<ArrowBackIcon />}>
                          Back to Review
                        </SbButton>

                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                          <Typography
                            variant="body2"
                            sx={{ color: theme.palette.text.secondary, display: { xs: 'none', sm: 'block' } }}
                          >
                            Total: <strong>{bulkShipments.length} Shipments</strong>
                          </Typography>
                          <SbButton
                            variant="contained"
                            onClick={handlePlaceBulkShipment}
                            disabled={isStep1Disabled()}
                            sx={{
                              py: 1.2,
                              px: 3.5,
                              fontSize: '0.95rem',
                              fontWeight: 700,
                              borderRadius: '10px',
                              boxShadow: `0 4px 14px ${alpha(theme.palette.primary.main, 0.35)}`,
                            }}
                          >
                            Place {bulkShipments.length} Shipments
                          </SbButton>
                        </Box>
                      </Paper>
                    </Grid>
                  </Grid>
                )}
              </Box>
            </Loader>
          )}

          {/* Edit Form Modal */}
          {editingShipmentIndex !== null && (
            <EditBulkShipmentModal
              shipment={bulkShipments[editingShipmentIndex]}
              onClose={() => setEditingShipmentIndex(null)}
              onSave={updated => {
                setBulkShipments(prev => {
                  const copy = [...prev];
                  copy[editingShipmentIndex] = updated;
                  return copy;
                });
                setEditingShipmentIndex(null);
              }}
              countryList={countryList}
              currencyList={currencyList}
            />
          )}
        </Box>
      ) : (
        <Grid>
          <Grid container>
            {isMobile && (
              <Grid item xs={12} sx={{ pb: { md: 0, xs: 2 } }}>
                <Typography className="font-bold">{`${detailsFor} Details`}</Typography>{' '}
              </Grid>
            )}
            <Grid item xs={12}>
              <Grid container spacing={2} alignItems="center" justifyContent={{ xs: 'start' }}>
                <Grid item>
                  <SavedAddresses
                    key={detailsFor}
                    addresses={
                      detailsFor === USER_TYPE.SHIPPER
                        ? shipperAddresses || []
                        : detailsFor === USER_TYPE.CONSIGNEE
                        ? consigneeAddresses || []
                        : []
                    }
                    setSelectedAddress={address => setSelectedAddress(address)}
                  />
                </Grid>
                <Grid item>
                  <SbButton
                    variant="outlined"
                    onClick={handleAiImportClick}
                    disabled={isImporting}
                    startIcon={<AutoAwesomeIcon sx={{ color: isImporting ? '#fff' : '#7c4dff' }} />}
                    sx={{
                      fontSize: '14px',
                      borderRadius: '8px !important',
                      height: '40px',
                      borderColor: isImporting ? 'transparent' : '#7c4dff',
                      color: isImporting ? '#fff' : '#7c4dff',
                      backgroundImage: isImporting
                        ? 'linear-gradient(270deg, #7c4dff, #ff4081, #00e5ff, #7c4dff)'
                        : 'none',
                      backgroundSize: '400% 400%',
                      animation: isImporting ? 'geminiGlow 3s ease infinite' : 'none',
                      '&:hover': {
                        borderColor: '#651fff',
                        backgroundColor: 'rgba(124, 77, 255, 0.04)',
                      },
                      '&.Mui-disabled': {
                        backgroundImage: isImporting
                          ? 'linear-gradient(270deg, #7c4dff, #ff4081, #00e5ff, #7c4dff) !important'
                          : 'none',
                        backgroundSize: '400% 400%',
                        animation: isImporting ? 'geminiGlow 3s ease infinite !important' : 'none',
                        color: isImporting ? '#fff !important' : 'rgba(0, 0, 0, 0.26) !important',
                        borderColor: isImporting ? 'transparent !important' : 'rgba(0, 0, 0, 0.12) !important',
                        cursor: 'not-allowed',
                      },
                    }}
                  >
                    {isImporting ? 'Analyzing...' : ' Import with AI'}
                  </SbButton>
                  <input
                    type="file"
                    ref={fileInputRef}
                    style={{ display: 'none' }}
                    onChange={handleFileChange}
                    accept=".xlsx,.xls,.pdf,.png,.jpg,.jpeg,.doc,.docx,.txt,.csv"
                    multiple
                  />
                  <ImportAiModal
                    open={isModalOpen}
                    onClose={() => setIsModalOpen(false)}
                    isImporting={isImporting}
                    onUploadClick={() => fileInputRef.current?.click()}
                    onExtractText={performTextExtraction}
                    error={extractionError}
                    setError={setExtractionError}
                  />
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          <Divider sx={{ my: { md: 4, xs: 2 } }} />
          <Grid container alignItems={'center'}>
            <Grid item lg={2} md={2} xs={12}>
              <InputLabel className="font-medium md-text" sx={{ mb: { xs: 1, md: 0 } }} required>
                {`${detailsFor} Name`}
              </InputLabel>
            </Grid>
            <Grid item lg={10} md={10} xs={12}>
              <SbTextField
                onChange={handleChange}
                placeholder="Enter Name"
                name="name"
                required
                value={initials.name}
                error={errors.name}
              />
            </Grid>
          </Grid>
          <Divider sx={{ my: { md: 4, xs: 2 } }} />
          <Grid container alignItems={'center'}>
            <Grid item lg={2} md={2} xs={12}>
              <InputLabel className="font-medium md-text" sx={{ mb: { xs: 1, md: 0 } }}>
                Company Name
              </InputLabel>
            </Grid>
            <Grid item lg={10} md={10} xs={12}>
              <SbTextField
                placeholder="Enter Company Name"
                value={initials.companyName}
                onChange={handleChange}
                name="companyName"
                error={errors.companyName}
              />
            </Grid>
          </Grid>
          <Divider sx={{ my: { md: 4, xs: 2 } }} />
          <Grid container alignItems={'center'}>
            <Grid item lg={2} md={2} xs={12}>
              <InputLabel className="font-medium md-text" sx={{ mb: { xs: 1, md: 0 } }}>
                Contact
              </InputLabel>
            </Grid>
            <Grid container item lg={10} md={10} xs={12} columnSpacing={3}>
              <Grid item md={6} xs={12} sx={{ mb: { md: 0, xs: 2 } }}>
                <Contact
                  label="Mobile No. *"
                  phoneName="phoneNumber"
                  phoneNumber={initials.phoneNumber || ''}
                  onChangePhoneNumber={handleChange}
                  telCountryCodeName="telephoneCode"
                  telCountryCode={initials.telephoneCode || ''}
                  onChangeTelCountryCode={handleChange}
                  setDefaultTelephone={(value: number) => handleCountryCodeChange('telephoneCode', value.toString())}
                  error={errors.phoneNumber || errors.telephoneCode}
                  validationState={validationStates[`${detailsFor}.phoneNumber`] || validationStates['phoneNumber']}
                  onApplySuggestion={suggestion => {
                    setInitials(prev => ({ ...prev, phoneNumber: suggestion }));
                  }}
                />
              </Grid>
              <Grid item md={6} xs={12}>
                <SbTextField
                  placeholder="Enter Email Id"
                  label="Email Address"
                  onChange={handleChange}
                  name="email"
                  value={initials.email}
                  error={errors.email}
                  validationState={validationStates['email']}
                  onApplySuggestion={suggestion => {
                    setInitials(prev => ({ ...prev, email: suggestion }));
                  }}
                />
              </Grid>
            </Grid>
          </Grid>
          <Divider sx={{ my: { md: 4, xs: 2 } }} />
          <Grid container>
            <Grid item lg={2} md={2} xs={12}>
              <InputLabel className="font-medium md-text" sx={{ mb: { xs: 1, md: 0 } }}>
                Address
              </InputLabel>
            </Grid>
            <Grid container item lg={10} md={10} xs={12} spacing={3}>
              <Grid item md={12} xs={12}>
                <GoogleMaps
                  onSelect={handleSelectedAddress}
                  label={'Location'}
                  placeholder="Start typing to search for location"
                  reinitialize={reinitialize}
                />
              </Grid>
              <Grid item md={6} xs={12}>
                <SbTextField
                  placeholder="Line 1"
                  label="Address Line 1"
                  required
                  value={initials.line1}
                  onChange={handleChange}
                  name="line1"
                  error={errors.line1}
                  helperText={`${initials.line1}`}
                  showCharCount={true}
                />
              </Grid>
              <Grid item md={6} xs={12}>
                <SbTextField
                  placeholder="Line 2"
                  label="Address Line 2"
                  // required
                  value={initials.line2}
                  onChange={handleChange}
                  name="line2"
                  error={errors.line2}
                  helperText={`${initials.line2}`}
                  showCharCount={true}
                />
              </Grid>
              <Grid item md={6} xs={12}>
                <SbTextField
                  placeholder="City"
                  label="City"
                  required
                  value={initials.city}
                  onChange={handleChange}
                  name="city"
                  error={errors.city}
                />
              </Grid>
              <Grid item md={6} xs={12}>
                <SbTextField
                  placeholder="State"
                  label="State"
                  // required
                  value={initials.state}
                  onChange={handleChange}
                  name="state"
                  error={errors.state}
                />
              </Grid>
              <Grid item md={6} xs={12}>
                <SBDropdown
                  id="company-country-id"
                  label={'Country'}
                  required
                  name="country"
                  placeholder="Country"
                  options={countryList}
                  value={initials.country ? [initials.country] : []}
                  onChange={handleDropdownChange}
                  error={errors.country}
                />
              </Grid>
              <Grid item md={6} xs={12}>
                <SbTextField
                  placeholder="Pincode"
                  label="Pincode"
                  required
                  value={initials.pincode}
                  onChange={handleChange}
                  name="pincode"
                  error={errors.pincode}
                  validationState={validationStates[`${detailsFor}.address`]}
                  onApplySuggestion={suggestion => {
                    setInitials(prev => ({ ...prev, pincode: suggestion }));
                  }}
                />
                {pincodeServiceabilityForShipment !== null &&
                  disablePickup === true &&
                  detailsFor === USER_TYPE.SHIPPER && (
                    <FormHelperText error className="m-0">
                      Pickup serviceability not available for this pincode
                    </FormHelperText>
                  )}
              </Grid>
            </Grid>
          </Grid>
          <Divider sx={{ my: { md: 4, xs: 2 } }} />
          <Grid container alignItems={'center'}>
            <Grid item lg={2} md={2} xs={12}>
              <InputLabel className="font-medium md-text" sx={{ mb: { xs: 1, md: 0 } }}>
                Alternate contact
              </InputLabel>
            </Grid>
            <Grid container item lg={10} md={10} xs={12} spacing={3}>
              <Grid item md={6} xs={12}>
                <SbTextField
                  placeholder="Enter name"
                  label="Name"
                  name="altContactName"
                  onChange={handleChange}
                  value={initials.altContactName}
                />
              </Grid>
              <Grid item md={6} xs={12}>
                <Contact
                  label={initials.altContactName ? 'Mobile No. *' : 'Mobile No.'}
                  phoneName="altContactNo"
                  phoneNumber={initials.altContactNo || ''}
                  onChangePhoneNumber={handleChange}
                  telCountryCodeName="altContactTelephoneCode"
                  telCountryCode={initials.altContactTelephoneCode || ''}
                  onChangeTelCountryCode={handleChange}
                  setDefaultTelephone={(value: number) =>
                    handleCountryCodeChange('altContactTelephoneCode', value.toString())
                  }
                  error={errors.altContactNo || errors.altContactTelephoneCode}
                />
              </Grid>
            </Grid>
          </Grid>
          <Divider sx={{ my: { md: 4, xs: 2 } }} />
          {/* <Grid container className="mt-1">
            <Grid item lg={2} md={2} xs={12}>
              <InputLabel className="font-medium md-text" sx={{ mb: { xs: 1, md: 0 } }}>{`${detailsFor} ID`}</InputLabel>
            </Grid>
            <Grid container item lg={10} md={10} xs={12} spacing={3}>
              <Grid item md={6} xs={12}>
                <SBDropdown
                  id="company-country-id"
                  label={`${detailsFor} Type`}
                  placeholder="Personal Shipments"
                  name="type"
                  value={initials.type ? [initials.type] : []}
                  options={shipmentIdTypeList}
                  onChange={handleDropdownChange}
                />
              </Grid>
              <Grid item md={6} xs={12}>
                <SBDropdown
                  label={`${detailsFor} ID Type`}
                  id="IdType"
                  placeholder="Select ID ype"
                  name="IdType"
                  value={initials.IdType ? [initials.IdType] : []}
                  options={typeOption || []}
                  onChange={handleDropdownChange}
                />
              </Grid>
              <Grid item md={12} xs={12}>
                <SbTextField
                  label={`${detailsFor} ID No.`}
                  placeholder="ID Number"
                  name="IdNumber"
                  value={initials.IdNumber}
                  onChange={handleChange}
                />
              </Grid>
            </Grid>
          </Grid> */}
          {/* <Divider sx={{ my: { md: 4, xs: 2 } }} /> */}
          <Grid container alignItems={'baseline'}>
            <Grid item lg={2} md={2} xs={12}>
              <InputLabel className="font-medium md-text" sx={{ mb: { xs: 1, md: 0 } }}>
                Save as
              </InputLabel>
            </Grid>
            <Grid container item lg={10} md={10} xs={12} spacing={3}>
              <Grid item md={6} xs={12}>
                <TextField
                  placeholder="Save as"
                  // label={'⠀'}
                  value={saveAs}
                  variant="standard"
                  onChange={event => setSaveAs(event.target.value)}
                  sx={{ fontSize: '14px', height: '44px', width: '100%' }}
                />
              </Grid>
            </Grid>
          </Grid>
          {name !== 'Cargo Solutions Network' && detailsFor === 'Shipper' && (
            <>
              <Divider sx={{ my: { md: 4, xs: 2 } }} />
              <Grid container>
                <Grid item lg={2} md={2} xs={12}>
                  <InputLabel className="font-medium md-text" sx={{ mb: { xs: 1, md: 0 } }}>
                    {name === 'Cargo Solutions Network' ? 'Drop-off Warehouse' : 'Pickup or Drop-off?'}
                  </InputLabel>
                </Grid>
                <Grid container item lg={10} md={10} xs={12} spacing={3}>
                  <ShipmentPickupType
                    pincode={initials.pincode}
                    userId={props.userId}
                    warehouse={errors.warehouse || ''}
                    date={errors.date || ''}
                    timeSlot={errors.timeSlot || ''}
                    selectedCountry={initials.country}
                  />
                </Grid>
              </Grid>
            </>
          )}
          <Actions
            onNext={validateForm}
            details={{ ...initials }}
            detailsFor={detailsFor}
            userId={props.userId}
            accountNumber={props.accountNumber}
            accountId={props.accountId}
          />
        </Grid>
      )}
    </>
  );
}

export default UserDetails;
